import './AccountMenu.css';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useViewWidth } from '@utils/helpers/viewWidth';
import { useCanShowLeaderboard } from '@components/navigation/canShowLeaderboard';
import {
  AccountMenuItem,
  AccountMenuItemSpan,
} from './styles/AccountMenu.style';
import { useStore } from 'jotai';
import { haveBottomNavbar } from '@atom/navbarAtom';
import {
  AccountMenuGroupItem,
  AccountMenuItem as AccountMenuItemInterface,
  useAccountMenuList,
} from '@components/navigation/ListHook/AccountMenuListHook';
import { useUserDetails } from '@hooks/user.hook';
import { USER_VN_STUDENT } from '@utils/constants/user.constants';

interface AccountMenuProps {
  setShowAccountDropdown?: React.Dispatch<React.SetStateAction<boolean>>;
  showAccountDropdown?: boolean;
  isJC?: boolean;
  className?: string;
}

const breakpoint = require('geniebook-ui/dist/themes/breakpoint');
const AccountMenu = (props: AccountMenuProps) => {
  const store = useStore();
  const location = useLocation();
  const width = useViewWidth();
  const menuList: AccountMenuGroupItem[] = useAccountMenuList();
  const showLeaderboard = useCanShowLeaderboard();
  const userDetailQuery = useUserDetails();

  const menuVisibilityRules: Record<
    string,
    (menu: AccountMenuItemInterface) => void
  > = {
    'menu-leaderboard': (menu: AccountMenuItemInterface) => {
      menu.hide = !showLeaderboard;
    },
    'menu-exam-result': (menu: AccountMenuItemInterface) => {
      menu.hide = userDetailQuery?.data?.data.country_code === USER_VN_STUDENT;
    },
    'menu-badges': (menu: AccountMenuItemInterface) => {
      menu.hide = props.isJC;
    },
  };

  for (let i = 0; i < menuList.length; i++) {
    if (menuList[i].key === 'group-achievement') {
      for (let j = 0; j < menuList[i].child.length; j++) {
        const currentMenu = menuList[i].child[j];
        const rule = menuVisibilityRules[currentMenu.key];
        if (rule) {
          rule(currentMenu);
        }
      }
      break;
    }
  }

  return (
    <div className={`account-menu-container relative z-[2] ${props.className}`}>
      {menuList.map((menuGroup: AccountMenuGroupItem, index: number) => {
        return (
          <div
            className={`account-menu-group ${index > 0 ? 'mt-6' : ''}`}
            key={menuGroup.key}
          >
            <p className="uppercase text-xs leading-3 font-black text-neutral-whiteboard text-left opacity-50 mb-2">
              {menuGroup.label}
            </p>
            <div className="account-menu-item-container w-[254px]">
              {menuGroup.child
                .filter(menuItem => !menuItem.hide)
                .map(menuItem => {
                  if (!menuItem.externalLink) {
                    return (
                      <Link
                        to={menuItem.url}
                        key={menuItem.key}
                        onClick={() => {
                          if (
                            menuItem.label === 'Badges' ||
                            menuItem.label === 'Leaderboard'
                          )
                            store.set(haveBottomNavbar, false);
                          if (props.setShowAccountDropdown)
                            props.setShowAccountDropdown(false);
                        }}
                        id={menuItem.domId}
                      >
                        <AccountMenuItem
                          isActive={
                            width > breakpoint.lg &&
                            location.pathname == menuItem.url
                          }
                        >
                          <p>
                            {<menuItem.icon />}
                            <AccountMenuItemSpan>
                              {menuItem.label}
                            </AccountMenuItemSpan>
                          </p>
                        </AccountMenuItem>
                      </Link>
                    );
                  }
                  return menuItem.url.indexOf('http') !== -1 ? ( // we are using a href for external link
                    <a
                      href={menuItem.url}
                      key={menuItem.key}
                      target="_blank"
                      id={menuItem.domId}
                      rel="noreferrer"
                    >
                      <AccountMenuItem>
                        <p>
                          {<menuItem.icon />}
                          <AccountMenuItemSpan>
                            {menuItem.label}
                          </AccountMenuItemSpan>
                        </p>
                      </AccountMenuItem>
                    </a>
                  ) : (
                    // and router link for internal link
                    <Link
                      to={menuItem.url}
                      key={menuItem.key}
                      id={menuItem.domId}
                    >
                      <AccountMenuItem>
                        <p>
                          {<menuItem.icon />}
                          <span>{menuItem.label}</span>
                        </p>
                      </AccountMenuItem>
                    </Link>
                  );
                })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AccountMenu;
